import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

/**
 * Sign-in button using popup flow. Sets active account on success.
 */
export const SignInButton = () => {
    const { instance, accounts } = useMsal();

    const handleLogin = async () => {
        try {
            // If already signed in, do nothing.
            if (accounts && accounts.length > 0) {
                instance.setActiveAccount(accounts[0]);
                return;
            }
            const result = await instance.loginPopup(loginRequest);
            if (result?.account) {
                instance.setActiveAccount(result.account);
            }
        } catch (e) {
            console.error(e);
        }
    };

    return <button onClick={handleLogin} aria-label="Sign in with your account">Sign in</button>;
};
